import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.setMinHeight)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(`min-height:${
      $setup.fixedMinHeight ? $setup.fixedMinHeight : $props.minHeight ?? 164
    }px`),
        ref: "targetEl"
      }, [
        ($setup.shouldRender)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : _createCommentVNode("", true)
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}